import recreateAccessToken from '@/api/auth/recreateAccessToken.endpoint';
import useCustomHook from '@/hooks/useCustomHook';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';
import setAuthenticatedUser from 'src/modules/auth/setAuthenticatedUser';
import waitForPendingSubscriptionPayment from 'src/modules/subscriptions/waitForPendingSubscriptionPayment';

export default function usePaymentResult() {
  const router = useRouter();
  const globalContext = useContext(GlobalContext);

  const { state, actions } = useCustomHook({
    defaultState: {
      loading: true,
      status: null,
    },
    actions: {
      checkResult: async (subscriptionPaymentId) => {
        try {
          const subscriptionPayment = await waitForPendingSubscriptionPayment(
            subscriptionPaymentId
          );
          if (subscriptionPayment.status == 'success') {
            const response = await recreateAccessToken();
            await setAuthenticatedUser({
              accessToken: response.token,
              context: globalContext,
            });
          }
          actions.setState({
            loading: false,
            status: subscriptionPayment.status,
          });
        } catch (e) {
          console.error(e);
          actions.setState({ loading: false, status: 'error' });
        }
      },
    },
  });

  useEffect(() => {
    if (router.isReady && router.query.subscriptionPaymentId) {
      actions.checkResult(router.query.subscriptionPaymentId);
    }
  }, [router.isReady, router.query.subscriptionPaymentId]);

  return { state, actions };
}
